import React from 'react';
import { DateField, TextField, SimpleShowLayout, Show } from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import InvoiceShowActions from './InvoiceShowActions';

const InvoiceShow = props => (
	<Show {...props} actions={<InvoiceShowActions />}>
		<SimpleShowLayout>
			<TextField source="id" />
			<DateField source="creationDateTime" showTime />
			<AmountField source="amount" />
			<AmountField source="vatAmount" />
			<TextField source="invoiceType" />
			<TextField source="invoiceStatus" />
			<TextField source="description" />
			<TextField source="customType" />
		</SimpleShowLayout>
	</Show>
);

export default InvoiceShow;
